import React, { createContext, useState, useMemo, useContext, useEffect } from 'react'

export const PageTitleContext = createContext()

export function PageTitleProvider({ children }) {
  const [pageTitle, setPageTitle] = useState('')
  const value = useMemo(
    () => ({
      setPageTitle,
      pageTitle,
    }),
    [pageTitle, setPageTitle]
  )
  return <PageTitleContext.Provider value={value}>{children}</PageTitleContext.Provider>
}

export function usePageTitle(title) {
  const { setPageTitle } = useContext(PageTitleContext)

  useEffect(() => {
    setPageTitle(title)
  }, [title, setPageTitle])
}
